import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import css from '../../../styles/common.module.scss';
import cssVariables from '../../../../../src/common/styles/variables';
import debounce from '../../../utils/debounce';
import getSubscribeEventLabel from '../../../utils/subscription/getSubscribeEventLabel';
import { labels } from '../../../constants/analytics/categoryActionLabel/subscribe';
import { openUpsellAndTrackActivity } from '../../../actions/dialog';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';

/* eslint-disable max-len */
export class PremiumLogo extends Component {
  static propTypes = {
    guideId: PropTypes.string.isRequired,
    products: PropTypes.array,
    image: PropTypes.string,
    title: PropTypes.string,
    actions: PropTypes.object.isRequired,
  };

  static contextType = LocationAndLocalizationContext;

  constructor(props, context) {
    super(props, context);
    this.handleClick = debounce(this.handleClick.bind(this));
  }

  handleClick() {
    const { guideId, products, image, title, actions } = this.props;
    const { location } = this.context;

    const eventLabel = getSubscribeEventLabel(
      labels.profileUpsellDialog,
      location,
    );
    actions.openUpsellAndTrackActivity(
      eventLabel,
      guideId,
      null,
      products,
      image,
      title,
    );
  }

  render() {
    const tuneInCoral = cssVariables['--tunein-coral'];

    return (
      <svg
        className={css.overlay}
        onClick={this.handleClick}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 96 24"
      >
        <title>Asset 8</title>
        <g id="13c8cf52-a3aa-4124-b3be-1c3050a3d28a" data-name="Layer 2">
          <g id="3f52c768-5775-4ee0-ba89-119b2f102e84" data-name="Layer 1">
            <rect width="96" height="24" rx="1" ry="1" fill={tuneInCoral} />
            <path
              d="M9,16.72V7.47a.29.29,0,0,1,.28-.28h3.08a2.8,2.8,0,0,1,2.94,3,2.78,2.78,0,0,1-2.94,2.94H11.1a.13.13,0,0,0-.14.14v3.5a.29.29,0,0,1-.28.28H9.28A.29.29,0,0,1,9,16.72Zm3.29-5.6a1,1,0,1,0,0-2H11.1A.13.13,0,0,0,11,9.3V11a.14.14,0,0,0,.14.14Z"
              fill="#fff"
            />
            <path
              d="M17.26,16.72V7.47a.29.29,0,0,1,.28-.28h3.08a2.8,2.8,0,0,1,2.94,3,2.68,2.68,0,0,1-1.45,2.48c-.1.05-.16.11-.16.19a.87.87,0,0,0,.07.27l1.45,3.33a.71.71,0,0,1,.07.27.32.32,0,0,1-.35.32H21.78c-.18,0-.26-.06-.35-.25L20,13.26a.27.27,0,0,0-.25-.18h-.37a.13.13,0,0,0-.14.14v3.5a.29.29,0,0,1-.28.28h-1.4A.29.29,0,0,1,17.26,16.72Zm3.29-5.6a1,1,0,0,0,0-2H19.36a.13.13,0,0,0-.14.14V11a.14.14,0,0,0,.14.14Z"
              fill="#fff"
            />
            <path
              d="M25.73,16.72V7.47A.29.29,0,0,1,26,7.19h5.08a.29.29,0,0,1,.29.28V8.88a.29.29,0,0,1-.29.28H27.83a.13.13,0,0,0-.14.14V11a.14.14,0,0,0,.14.14H31a.27.27,0,0,1,.28.28v1.4a.28.28,0,0,1-.28.28H27.83a.13.13,0,0,0-.14.14V14.9a.14.14,0,0,0,.14.14h3.32a.28.28,0,0,1,.28.28v1.4a.28.28,0,0,1-.28.28H26A.29.29,0,0,1,25.73,16.72Z"
              fill="#fff"
            />
            <path
              d="M33.67,16.72V7.47A.28.28,0,0,1,34,7.19H36a.27.27,0,0,1,.29.24l1.43,6.32c0,.11.06.15.11.15s.1,0,.13-.15L39.4,7.43a.27.27,0,0,1,.29-.24h2.06a.29.29,0,0,1,.28.28v9.25a.29.29,0,0,1-.28.28H40.52a.28.28,0,0,1-.28-.28v-5.6c0-.13,0-.17-.07-.17s-.09,0-.1.11l-1.37,5.7a.28.28,0,0,1-.3.24H37.3a.28.28,0,0,1-.3-.24l-1.37-5.7c0-.08-.06-.11-.1-.11s-.07,0-.07.17v5.6a.29.29,0,0,1-.28.28H34A.28.28,0,0,1,33.67,16.72Z"
              fill="#fff"
            />
            <path
              d="M45.88,9.09H44.34a.28.28,0,0,1-.28-.28V7.47a.28.28,0,0,1,.28-.28h5.32a.29.29,0,0,1,.28.28V8.81a.29.29,0,0,1-.28.28H48.12a.13.13,0,0,0-.14.14V15a.13.13,0,0,0,.14.14H49.8a.28.28,0,0,1,.28.28v1.33a.29.29,0,0,1-.28.28H44.2a.28.28,0,0,1-.28-.28V15.39a.27.27,0,0,1,.28-.28h1.68A.14.14,0,0,0,46,15V9.23A.13.13,0,0,0,45.88,9.09Z"
              fill="#fff"
            />
            <path
              d="M51.76,14.06V7.47A.28.28,0,0,1,52,7.19h1.41a.29.29,0,0,1,.28.28v6.59a1.29,1.29,0,0,0,2.55,0V7.47a.29.29,0,0,1,.28-.28H58a.29.29,0,0,1,.28.28v6.59a3.25,3.25,0,0,1-6.5,0Z"
              fill="#fff"
            />
            <path
              d="M60.84,16.72V7.47a.29.29,0,0,1,.28-.28h2.06a.29.29,0,0,1,.3.24l1.42,6.32c0,.11.06.15.12.15s.09,0,.12-.15l1.43-6.32a.28.28,0,0,1,.3-.24h2a.28.28,0,0,1,.28.28v9.25a.28.28,0,0,1-.28.28H67.69a.29.29,0,0,1-.28-.28v-5.6c0-.13,0-.17-.07-.17s-.08,0-.1.11l-1.37,5.7a.27.27,0,0,1-.29.24H64.47a.27.27,0,0,1-.29-.24l-1.38-5.7c0-.08,0-.11-.09-.11s-.08,0-.08.17v5.6a.28.28,0,0,1-.28.28H61.12A.29.29,0,0,1,60.84,16.72Z"
              fill="#fff"
            />
            <path
              d="M86.5,11h-.75V9.5a3.25,3.25,0,0,0-6.5,0V11H78.5a.5.5,0,0,0-.5.5v5a.5.5,0,0,0,.5.5h8a.5.5,0,0,0,.5-.5v-5A.5.5,0,0,0,86.5,11ZM80.75,9.5a1.75,1.75,0,0,1,3.5,0V11h-3.5Z"
              fill="#fff"
            />
            <circle cx="82.5" cy="14" r="1" fill={tuneInCoral} />
          </g>
        </g>
      </svg>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        openUpsellAndTrackActivity,
      },
      dispatch,
    ),
  };
}

export default connect(null, mapDispatchToProps)(PremiumLogo);
